<div class="page-content">
  <form [formGroup]="formGroup" (ngSubmit)="submit($event)" autocomplete="off">
    <h1>Create an Account</h1>
    <h2>Welcome to <span>Pink</span><span>Soul</span> 👋</h2>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput placeholder="" formControlName="fname" maxlength="60" />
        <mat-error>Please enter first name.</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput placeholder="" formControlName="lname" maxlength="60" />
        <mat-error>Please enter last name.</mat-error>
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input
        matInput
        placeholder=""
        formControlName="email"
        (ngModelChange)="formGroup.get('email')?.setErrors(null)"
      />
      <mat-icon matPrefix>mail</mat-icon>
      <mat-error>Please enter a valid email.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Password</mat-label>
      <input
        matInput
        placeholder=""
        type="password"
        formControlName="password"
      />
      <mat-icon matPrefix>lock</mat-icon>
      <mat-error>At least 8 characters and 1 uppercase letter.</mat-error>
    </mat-form-field>

    <p class="policy">
      * By signing up, you agree to our
      <a routerLink="/terms-of-service" aria-label="Terms of Service"
        >Terms of Use</a
      >
      and
      <a routerLink="/privacy-policy" aria-label="Privacy Policy"
        >Privacy Policy</a
      >
    </p>
    <app-button type="filled" [loading]="loading">Signup</app-button>
  </form>
</div>
